import {useEffect, useState} from "react"

import "./Test.css"

import TestNav from "../../component/Nav/TestNav"
import RightFooter from "../../component/Footer/RightFooter"
import TopHeader from "../../component/Nav/TopHeader"
import PersonalTab from "../../component/Test/PersonalTab"
import PreviewModal from "../../component/Modal/PreviewModal"
import {retrieveData, sendRequest} from "../../common";
import {useNavigate} from "react-router-dom";

function PersonalWaiting() {

	const navigate = useNavigate()

	const [previewOpen, setPreviewOpen] = useState(false)
	const showPreview = () => {
		setPreviewOpen(true)
	}

	const [user, setUser] = useState()

	const [sendAll, setSendAll] = useState(false)
	const [applyTests, setApplyTests] = useState([])
	const [organization, setOrganization] = useState()
	const [inquiryPhone, setInquiryPhone] = useState()

	const [selected, setSelected] = useState([])

	const getWaitApplyTests = (user) => {
		sendRequest(`test/apply-test/?sender=${user?.id}&isSent=False&size=1000&group=개인`, 'GET', null, data => {
			setApplyTests(data)
		})
	}

	useEffect(() => {
		retrieveData('user').then(user => {
			setUser(user)
			setOrganization(user?.organization)
			setInquiryPhone(user?.inquiryPhone)
			getWaitApplyTests(user)
		})
	}, [])

	const sendCodes = () => {
		setTimeout(() => alert('모두 발송 되었습니다.'), 1000)
		sendRequest('test/send-apply-test/', 'POST', {
			applyTestIds: sendAll ? applyTests?.map(item => item.id) : selected,
			organization,
			inquiryPhone
		}, data => {
			setPreviewOpen(false)
			getWaitApplyTests(user)
			navigate('/personal-code/send-complete')
		})
	}

	const onSelected = (checked, id) => {
		if (checked) {
			selected.push(id)
			setSelected(Object.assign([], selected))
		} else {
			const index = selected.indexOf(id)
			if (index !== -1) {
				selected.splice(index, 1)
				setSelected(Object.assign([], selected))
			}
		}
	}

	const deleteAll = (applyTests, index) => {
		if (applyTests?.length -1 < index) {
			getWaitApplyTests(user)
			setSelected([])
			alert('모두 삭제 되었습니다.')
			return
		}

		sendRequest(`test/apply-test/${applyTests[index]}/`, 'DELETE', null, data => {
			deleteAll(applyTests, index + 1)
		})
	}

	return (
		<>
			<TestNav />
			<div className="container">
				<div className="testContent">
					<TopHeader title={"개인검사 인증코드"} />
					<div className="testWrap">
						<PersonalTab isSecond={true} />
						<section className="personalWaiting">
							<form name="personalWaiting">
								<div className="tableTab">
									<div className="tableBtn"
										onClick={e => {
											e.preventDefault()
											deleteAll(selected, 0)
										}}
									>
										<button type="button">선택 삭제</button>
									</div>
									<span>총 {selected?.length}명</span>
								</div>
								<div className="testTableWrap">
									<table className="testTable">
										<colgroup>
											<col width="5%" />
											<col width="15%" />
											<col width="10%" />
											<col width="10%" />
											<col width="15%" />
											<col width="10%" />
											<col width="15%" />
											<col width="10%" />
											<col width="10%" />
										</colgroup>
										<thead>
											<tr>
												<th>
													<div className="formCheckbox">
														<input type="checkbox" id="tableSelect" required
																	 onChange={e => {
																		 if (e.target.checked) {
																			 setSelected(applyTests?.map((item, index) => item?.id))
																		 } else {
																			 setSelected([])
																		 }
																	 }}
														/>
														<label htmlFor="tableSelect"></label>
													</div>
												</th>
												<th>검사종류</th>
												<th>
													이름 <span className="required">*</span>
												</th>
												<th>생년월일</th>
												<th>개인고유번호</th>
												<th>소속기관</th>
												<th>
													이메일 <span className="required">*</span>
												</th>
												<th>
													휴대폰 번호 <span className="required">*</span>
												</th>
												<th>
													규준집단 <span className="required">*</span>
												</th>
											</tr>
										</thead>
										<tbody>
										{applyTests?.map((item, index) => {
											return (
												<tr>
													<td>
														<div className="formCheckbox">
															<input type="checkbox" id={`tableSelect${index}`} required checked={selected?.indexOf(item?.id) !== -1} onChange={e => onSelected(e.target.checked, item?.id)}/>
															<label htmlFor={`tableSelect${index}`}></label>
														</div>
													</td>
													<td>{item?.test?.name}</td>
													<td>{item?.name}</td>
													<td>{item?.birth}</td>
													<td>{item?.applyNumber}</td>
													<td>{item?.organization}</td>
													<td>{item?.email}</td>
													<td>{item?.phone}</td>
													<td>
													<span>
														<select value={item?.group} disabled={true} name="">
															<option defaultValue="">일반 성인</option>
															<option defaultValue="">대학생</option>
															<option defaultValue="">고등학생</option>
															<option defaultValue="">중학생</option>
															<option defaultValue="">초등학생</option>
														</select>
													</span>
													</td>
												</tr>
											)
										})}
										</tbody>
									</table>
								</div>
								<div className="testBtnWrap">
									<button type="button" onClick={() => {
										setSelected(applyTests?.map((item, index) => item?.id))
										setSendAll(true)
										showPreview()
									}}>전체 발송</button>
									<button type="button" onClick={() => {
										if (!selected?.length) {
											alert('명단을 선택해 주세요.')
											return
										}
										setSendAll(false)
										showPreview()
									}} className="keyBtn">
										선택 발송
									</button>
								</div>
							</form>
						</section>
					</div>
				</div>
			</div>

			{previewOpen && (
				<PreviewModal
					setPreviewOpen={setPreviewOpen}
					count={selected?.length}
					organization={organization}
					inquiryPhone={inquiryPhone}
					email={'kn820425@gmail.com'}
					send={"050-6607-1258"}
					setOrganization={setOrganization}
					setInquiryPhone={setInquiryPhone}
					user={user}
					onSend={sendCodes}
				/>
			)}

			<RightFooter />
		</>
	)
}

export default PersonalWaiting
